import React from 'react';

import logoLC from "../../images/ioai/logo_lc.png";
import logoAIML from "../../images/ioai/logo_aiml.png";
import logoSAChineseNews from "../../images/ioai/logo_sa_chinese_news.jpg";
import logoAAEGT from "../../images/ioai/logo_AAEGT.jpg";
import logoChess from "../../images/ioai/logo_chess.png";
import logoGTCASA from "../../images/ioai/logo_GTCASA.jpg";
import logoCityMedical from "../../images/ioai/logo_citymedical.png";
import logoSkinTech from "../../images/logo/skintech.jpg";
import logoHerTechPath from "../../images/logo/hertechpath.png";
import logoAusGov from "../../images/ioai/logo_aus_gov_DISER.png";
import logoDTF from "../../images/ioai/logo_DTF.jpg";
import logoIA from "../../images/ioai/logo_IA.png";
import logoOfficeAI from "../../images/ioai/logo_office_AI.png";
import logoIsoton from "../../images/ioai/logo_isoton.jpg";
import logoSARDI from "../../images/ioai/logo_sardi.jpg";
import logoCS from "../../images/ioai/logo_CS.jpg";
import logoEchoroam from "../../images/ioai/logo_echoroam.jpg";
import logoProtoforge from "../../images/ioai/logo_protoforge.jpg";
import logoWTC from "../../images/ioai/logo_WTC.jpg";
import logoFM from "../../images/ioai/logo_FM.jpg";
import logoMOne from "../../images/ioai/logo_M_one.jpg";





const images = [
    {
        img: logoLC,
        url: "https://www.leadingcoding.com.au",
    },
    {
        img: logoAIML,
        url: "https://www.adelaide.edu.au/aiml",
    },
    {
        img: logoSAChineseNews,
        url: "https://www.sacn.com.au",
    },
    {
        img: logoAAEGT,
        url: "https://www.aaegt.com",
    },
    {
        img: logoChess,
        url: "https://sajuniorchess.org",
    },
    {
        img: logoGTCASA,
        url: "https://www.gtcasa.com.au",
    },
    {
        img: logoCityMedical,
        url: "",
    },
    {
        img: logoSkinTech,
        url: "",
    },
    {
        img: logoHerTechPath,
        url: "https://hertechpath.org",
    },
    {
        img: logoAusGov,
        url: "https://www.industry.gov.au/",
    },
    {
        img: logoDTF,
        url: "https://www.treasury.sa.gov.au/",
    },
    {
        img: logoIA,
        url: "",
    },
    {
        img: logoOfficeAI,
        url: "https://www.ai.sa.gov.au/",
    },
    {
        img: logoIsoton,
        url: "https://www.isoton.com/",
    },
    {
        img: logoSARDI,
        url: "https://pir.sa.gov.au/sardi",
    },
    {
        img: logoCS,
        url: "https://www.coloursigns.com.au/",
    },
    {
        img: logoEchoroam,
        url: "https://echoroam.com/",
    },
    {
        img: logoProtoforge,
        url: "",
    },
    {
        img: logoWTC,
        url: "",
    },
    {
        img: logoFM,
        url: "",
    },
    {
        img: logoMOne,
        url: "",
    },
];

const PartnerScroll = () => {
    return (
        <div>
            <div className="image-container">
                <div className="image-wrapper">
                    <div className="images">
                        {images.map((image, index) => (
                            <a href={image.url} key={index} target="_blank" rel="noopener noreferrer">
                                <img className="image" src={image.img} alt={`Slide ${index + 1}`} />
                            </a>
                        ))}
                    </div>
                    <div className="images">
                        {images.map((image, index) => (
                            <a href={image.url} key={index} target="_blank" rel="noopener noreferrer">
                                <img className="image" src={image.img} alt={`Slide ${index + 1}`} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartnerScroll;